/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames';
import { InlineEdit } from '@components/v2/InlineEdit';
import Label from '@components/Label';
import './KeyValueList.scss';
export var IKeyValueType;
(function (IKeyValueType) {
    IKeyValueType["text"] = "text";
    IKeyValueType["date"] = "date";
    IKeyValueType["link"] = "link";
    IKeyValueType["address"] = "address";
    IKeyValueType["phone"] = "phone";
    IKeyValueType["number"] = "number";
})(IKeyValueType || (IKeyValueType = {}));
function KeyValueList({ items, onEdit }) {
    const parseLocalDate = (dateString) => {
        if (!dateString)
            return null;
        // Parse YYYY-MM-DD format manually to avoid timezone issues
        const parts = dateString.split('-');
        if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
            const day = parseInt(parts[2], 10);
            if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
                return new Date(year, month, day);
            }
        }
        // Fallback for other date formats
        const fallbackDate = new Date(dateString);
        return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
    };
    const getDateFormatted = (date) => {
        if (date) {
            const dateInstance = parseLocalDate(date);
            if (!dateInstance) {
                return 'Invalid Date';
            }
            return `${(dateInstance.getMonth() + 1).toString().padStart(2, '0')}/${dateInstance
                .getDate()
                .toString()
                .padStart(2, '0')}/${dateInstance.getFullYear()}`;
        }
        return '--';
    };
    return (React.createElement("div", { className: "keyValueListContainer" }, items.map((item) => (React.createElement("div", { className: "info-row", key: item.key },
        React.createElement(Label, { htmlFor: item.key, className: "info-key" },
            item.key,
            ":"),
        item.type === IKeyValueType.date && item.editable && (React.createElement(InlineEdit, { variant: "date", id: item.key, className: "info-value", dateValue: item.value ? parseLocalDate(item.value) || undefined : undefined, onDateChange: (date) => {
                var _a;
                if (date && !Number.isNaN(date.getTime())) {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit((_a = item.field) !== null && _a !== void 0 ? _a : '', date.toISOString().split('T')[0]);
                }
            }, label: item.key })),
        item.type === IKeyValueType.date && !item.editable && (React.createElement("span", { id: item.key, className: "info-value" }, getDateFormatted(item.value))),
        item.type === IKeyValueType.link && (React.createElement("a", { href: item.value, id: item.key, className: "qmb-link info-value", target: "_blank", rel: "noopener noreferrer" }, item.label)),
        item.type === IKeyValueType.address && (React.createElement("span", { id: item.key, className: "info-value" },
            item.value,
            " ",
            React.createElement("i", { className: "fa-light fa-location-dot" }))),
        item.type === IKeyValueType.text && (React.createElement(InlineEdit, { id: item.key, className: classNames('info-value', { highlightValue: item.highlight }), disableEdit: !item.editable, placeholder: "Enter text...", onBlur: (e) => {
                const value = e.currentTarget.textContent || '';
                if (value !== item.value && item.field)
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(item.field, value);
            } }, item.value)),
        item.type === IKeyValueType.phone && (React.createElement(InlineEdit, { variant: "phone", id: item.key, className: "info-value", phoneValue: item.value, onPhoneChange: (phone) => {
                if (phone && item.field) {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(item.field, phone);
                }
            } })),
        item.type === IKeyValueType.number && (React.createElement(InlineEdit, { variant: "number", id: item.key, className: classNames('info-value', { highlightValue: item.highlight }), disableEdit: !item.editable, placeholder: "Enter number...", numberValue: item.value, onNumberChange: (value) => {
                if (item.field) {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(item.field, value.toString());
                }
            }, allowDecimals: item.allowDecimals, allowNegative: item.allowNegative }, item.value)))))));
}
export default KeyValueList;
